import dayjs from "dayjs";

export const createDateFromProps = (date: string) => {
  return dayjs(date).format('DD.MM.YYYY');
};
